<template>
  <div class="index">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-row>
              <el-col>
                <el-form
                  ref="formData"
                  :model="formData"
                  :rules="rules"
                  label-width="100px"
                  class="demo-ruleForm">
                  <el-row>
                    <el-form-item
                      label="报账部门"
                      prop="department_id">
                      <el-select
                        v-model="formData.department_id"
                        class="jm-input220"
                        filterable
                        clearable
                        placeholder="请选择">
                        <el-option
                          v-for="item in department"
                          :key="item.id"
                          :label="item.department"
                          :value="item.id"/>
                      </el-select>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <el-form-item
                      label="目标时间"
                      prop="target_time">
                      <el-date-picker
                        v-model="formData.target_time"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="请选择月份"/>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <el-form-item
                      label="目标金额"
                      prop="target_money">
                      <el-input
                        class="jm-input220"
                        clearable
                        v-model="formData.target_money"
                        placeholder="请输入目标金额-数字"/>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="submitForm('formData')">提交编辑</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';

export default {
  data() {
    return {
      department: [],
      formData: {
        target_time: '', // 目标时间
        target_money: '', // 目标金额
        department_id: '' // 报账部门id
      },
      rules: {
        department_id: [
          { required: true, message: '请输入报账部门', trigger: 'blur' }
        ],
        target_time: [
          { required: true, message: '请输入目标时间', trigger: 'blur' }
        ],
        target_money: [
          { required: true, message: '请输入目标金额', trigger: 'blur' },
          { max: 5, message: '最多输入五位数字', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.$http._get({
      url: '/index/B_I_Department/departmentInformation',
      data: { id: this.$route.params.id }
    }).then(({ data }) => {
      this.formData = Object.assign({}, this.formData, data.data);
      this.department = data.department;
    }).catch(() => {
      this.$router.go(-1);
    });
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('报账业绩目标修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http._post({
              url: '/index/B_I_Department/DepartmentEdit',
              data: this.formData,
            }).then(({ data }) => {
              if (typeof data === 'string') {
                this.$message.error(data);
              } else if (typeof data === 'object') {
                this.$message({
                  type: 'success',
                  message: '编辑成功!'
                });
                this.$router.go(-1);
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消编辑'
            });
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
  },
};
</script>
